import { useReducer, useEffect } from 'react';

const initialState = (key, defaultValue) => {
	const storedValue = localStorage.getItem(key);
	if (storedValue) {
		return JSON.parse(storedValue);
	}
	return defaultValue;
};

const reducer = (state, action) => {
	switch (action.type) {
		case 'SET':
			return action.payload;

		case 'ADD':
			// Check if transaction exists, if so, update it
			const existingIndex = state.findIndex(transaction => transaction.transaction_id === action.payload.transaction_id);
			if (existingIndex !== -1) {
				const updatedState = [...state];
				updatedState[existingIndex] = action.payload;
				return updatedState;
			}
			return [...state, action.payload];

		case 'UPDATE':
			return state.map(transaction =>
				transaction.transaction_id === action.payload.transaction_id ? action.payload : transaction
			);

		case 'DELETE':
			return state.filter(transaction => transaction.transaction_id !== action.payload);

		default:
			throw new Error(`Unhandled action type: ${action.type}`);
	}
};

export default function useTransactionStorage(key, defaultValue) {
	const [state, dispatch] = useReducer(reducer, initialState(key, defaultValue));

	useEffect(() => {
		if (state === undefined) return;
		localStorage.setItem(key, JSON.stringify(state));
	}, [state, key]);

	return [state, dispatch];
}
